import React, { Component } from "react";

export default class CustomerDash extends Component {
  render() {
    return (
      <>
        <h1>Welcome Customer</h1>
      </>
    );
  }
}
